import React, {useState} from 'react';
import {isNumber} from 'lodash';
import {Modal, Button, Table, Popup, Message} from 'semantic-ui-react';

const Detail = ({totalsDetail}) => {
  const {
    jobsDealer,
    partsDealer,
    subcontDealer,
    jobsTde,
    partsTde,
    subcontTde,
    jobsDiff,
    partsDiff,
    subcontDiff,
  } = totalsDetail;

  return (
    <Table striped definition className='totals-detail'>
      <Table.Header>
        <Table.Row textAlign='center'>
          <Table.HeaderCell />
          <Table.HeaderCell>MANO DE OBRA</Table.HeaderCell>
          <Table.HeaderCell>PARTES</Table.HeaderCell>
          <Table.HeaderCell>SUBCONTRATOS</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        <Table.Row textAlign='center'>
          <Table.Cell>CONCESIONARIO</Table.Cell>
          <Table.Cell>{jobsDealer}</Table.Cell>
          <Table.Cell>{partsDealer}</Table.Cell>
          <Table.Cell>{subcontDealer}</Table.Cell>
        </Table.Row>
        <Table.Row textAlign='center'>
          <Table.Cell>TDE</Table.Cell>
          <Table.Cell>{isNumber(jobsTde) ? jobsTde : '-'}</Table.Cell>
          <Table.Cell>{isNumber(partsTde) ? partsTde : '-'}</Table.Cell>
          <Table.Cell>{isNumber(subcontTde) ? subcontTde : '-'}</Table.Cell>
        </Table.Row>
        <Table.Row textAlign='center'>
          <Table.Cell>DIFERENCIA</Table.Cell>
          <Table.Cell>{isNumber(jobsDiff) ? jobsDiff : '-'}</Table.Cell>
          <Table.Cell>{isNumber(partsDiff) ? partsDiff : '-'}</Table.Cell>
          <Table.Cell>{isNumber(subcontDiff) ? subcontDiff : '-'}</Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  );
};

const ErrorDetailModal = ({totalsDetail, invalid, updated, code}) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const openModal = () => {
    setModalIsOpen(true);
  };

  return (
    <Modal
      onOpen={openModal}
      open={modalIsOpen}
      className="error-detail-modal"
      trigger={
        <Popup
          trigger={
            <span className="link">
              <i className="material-icons" onClick={openModal}>
                visibility
              </i>
            </span>
          }
          content="Ver Detalle"
          position="top center"
          inverted
        />
      }
    >
      <Modal.Header>Detalle de Factura y Garantía</Modal.Header>
      <Modal.Content className="error-detail-content">
        {invalid && !code && (
          <Message negative>
            <Message.Header>Error</Message.Header>
            <p>Garantía no encontrada</p>
          </Message>
        )}
        {updated && code && (
          <Message warning>
            <Message.Header>Atención</Message.Header>
            <p>La garantía ya se encuentra actualizada</p>
          </Message>
        )}
        <Detail totalsDetail={totalsDetail} />
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={closeModal}>Cerrar</Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ErrorDetailModal;
